// Versione "lite" (palette awrabet/koba) dei template D.* (prematch-tournament) usati come
// intestazioni delle card nella home di gojjobet. Header oro, testo scuro.
import {h} from "preact";

export function CardHeaderRow({children}) {
	return <div class="cl-pt-card-head-row flex h-8 items-center border-t border-t-gojjo-lite-300 border-b border-b-gojjo-lite-300 bg-gojjo-gold-lite-400 text-gojjo-lite-950">{children}</div>
}

export function ThreeDots() {
	return <div class="cl-pt-3-dots flex h-full px-2">
	  <div class="flex h-full w-2 flex-none items-center justify-center"><div class="h-1 w-1 rounded-full bg-gojjo-lite-950"></div></div>
	  <div class="flex h-full w-2 flex-none items-center justify-center"><div class="h-1 w-1 rounded-full bg-gojjo-lite-950"></div></div>
	  <div class="flex h-full w-2 flex-none items-center justify-center"><div class="h-1 w-1 rounded-full bg-gojjo-lite-950"></div></div>
	</div>
}

export function CardHeaderTitle({children}) {
	return <div class="cl-pt-card-head-ttl min-w-0 grow truncate text-sm">{children}</div>
}

export function TournamentSportName({children}) {
	return <div class="cl-pt-tourn-sport-name min-w-0 truncate text-sm">{children}</div>
}
